import { useUserStore } from "./user/users";

interface GlobalQueryKey {
  [key: string]: string;
}
export const GLOBAL_QUERY_KEY = {
  subscriptionList: "GET_SUBSCRIPTIONS_LIST_GLOBAL",
  lockerHistory: "GET_LOCKER_HISTORY_GLOBAL",
  majorGiveaways: "GET_SUPER_GIVEAWAY_LIST_GLOBAL",
  mysteryAndSuperGiveaways: "GET_MYSTERY_AND_SUPER_GIVEAWAY_LIST_GLOBAL",
  cashGiveaways: "GET_CASH_GIVEAWAY_LIST_GLOBAL",
  ongoingGiveaway: "GET_SUPER_GIVEAWAY_RUNNING_GIVEAWAY_GLOBAL",
  pastGiveawaysList: "GET_SUPER_GIVEAWAY_PAST_GIVEAWAY_GLOBAL",
  pastGiveawayEligibilityAudit: "GET_PAST_GIVEAWAY_ELIGIBILITY_AUDIT_GLOBAL",
} satisfies GlobalQueryKey;

export { useUserStore };
